export default __webpack_public_path__ + "static/media/featured-item-18.3e713108.png";